// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2H23.0001L23.0001 19L18.2461 19L11.9998 12.7593L5.75476 19L1.00112 19L1 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 15.5872L7.75875 19.8301L5.33984 22.2442H8.1731L12.0003 18.4159L15.8286 22.2441H18.6618L12 15.5872Z"}}]};

const TvFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tv-filled',
    ref,
    icon: element,
  },
));

TvFilledIcon.displayName = 'TvFilledIcon';

export default TvFilledIcon;
